import styleSelect from 'styleselect'

/**
 * Init SelectStyle to all Selects.
 * http://mikemaccana.github.io/styleselect/
 */
export default function initStyleSelect() {
  const selects = document.querySelectorAll( 'select:not([class*="js-calc-"]):not(.appearance-none)' )

  setTimeout( () =>
    selects.forEach( select => {

      const firstOption = select.querySelector( 'option' )

      styleSelect( select )

      // Hide placeholder from options list if applicable.
      if ( firstOption.classList.contains( 'gf_placeholder' ) ) {
        select.nextSibling &&
          select.nextSibling.querySelector( '.ss-option' ) &&
            select.nextSibling.querySelector( '.ss-option' ).classList.add( 'hidden' )
      }
    })
  )
}
